export default __webpack_public_path__ + "static/media/hand.6e20d35b.png";